import { createFileRoute } from '@tanstack/react-router';
import { AdminProducts } from '../../components/admin/admin-products';

export const Route = createFileRoute('/admin/products')({
  component: AdminProducts,
});
